import React  from 'react';
import styles from './Accordion.scss';
import CSSModules from "react-css-modules";
import AccordionItem from './AccordionItem';

@CSSModules(styles, { allowMultiple: true })
class Accordion extends React.Component{

  constructor(props) {
    super(props);
    this.state = {activeIndex: this.props.openItem};

  }

  componentDidUpdate(prevProps,prevState, ) {
    if(prevProps.openItem !== this.props.openItem){
      this.setState({...prevState, activeIndex : this.props.openItem});
    }
  }

  handleToggle(itemIndex){
    this.setState({activeIndex:itemIndex});
  }
  render() {
    return (
      <div styleName="accordionContainer">
        {this.props.items.map((item,index) => {
          return  (<AccordionItem index={index} title={item.title} path={item.path} isActive={this.state.activeIndex !== undefined  && this.state.activeIndex === index}
                                 handleToggle={this.props.onClickMiddleware(item.path,this.handleToggle.bind(this))}  key={index}>
            <item.component/>
          </AccordionItem>);
        })
        }
      </div>
    );
  }
}

export default Accordion;




// WEBPACK FOOTER //
// ./src/components/common/Accordion/Accordion.js